import { createSlice } from '@reduxjs/toolkit';
import { AUTO_OPEN_INITIAL_SKIPPED_ANNOUNCEMENT, AUTO_OPEN_TOGGLE_DISMISSED_ANNOUNCEMENT, } from '../../const/announcementKeys';
import { APP_INSTALL } from '../../const/localStorageKeys';
const initialState = {};
const slice = createSlice({
    name: 'FLAGS',
    initialState,
    reducers: {
        set(state, action) {
            const flags = action.payload;
            return Object.assign(Object.assign({}, state), flags);
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
